// بطاقات الترويج الذاتي (على نمط Rightmove). كل بطاقة تروّج لإحدى ميزات صفقات 24.
// انظر src/config/promoContent.ts.
// مُغلّفة بمفتاح أعلى باسم `promo` لمطابقة نمط ملفات الترجمة الأخرى.
const promo = {
  promo: {
    // «استفد أكثر من صفقات 24» — تظهر للزوّار غير المسجّلين.
    createAccount: {
      title: 'استفد أكثر من صفقات 24',
      body: 'أنشئ حسابًا مجانيًا لحفظ العقارات المفضّلة لديك ومقارنتها ومتابعة بحثك من حيث توقّفت.',
      cta: 'أنشئ حسابًا أو سجّل الدخول',
    },

    // المقابل للمستخدم المسجّل في صفحتي البحث والعقار — يوجّه إلى المفضّلة.
    savedSearch: {
      title: 'تابِع بحثك بسهولة',
      body: 'احفظ العقارات التي تعجبك في قائمة المفضّلة وقارن بينها في أي وقت.',
      cta: 'عرض المفضّلة',
    },

    // جانب العرض: مقابل «كم تساوي قيمة منزلك؟» لدى Rightmove.
    listProperty: {
      title: 'لديك عقار للبيع أو الإيجار؟',
      body: 'اعرضه على صفقات 24 وصل إلى آلاف المشترين والمستأجرين في جميع أنحاء المملكة.',
      cta: 'أعلن عن عقارك',
    },

    // تحقيق الدخل: العضوية والنقاط والتمييز.
    membership: {
      title: 'انتقل إلى الباقة المميّزة',
      body: 'ميّز إعلاناتك، وافتح البحث الذكي، وتميّز عن غيرك مع باقات العضوية.',
      cta: 'استكشف العضوية',
    },

    // التفاعل: مؤشرات السوق من الصفقات المسجّلة (صفحة /market-tools).
    marketInsights: {
      title: 'اعرف السوق',
      body: 'استكشف أسعار الصفقات المسجّلة والإيجارات حسب الحي قبل أن تتخذ قرارك.',
      cta: 'استكشف مؤشرات السوق',
    },

    // النشرة البريدية — غير متاحة بعد (تظهر بشارة «قريباً»).
    newsletter: {
      title: 'اشترك في نشرتنا الأسبوعية',
      body: 'لا غنى عنها إن كنت تفكّر في الانتقال - أحدث الإعلانات ومستجدات السوق تصلك مباشرةً إلى بريدك.',
      cta: 'اشترك في النشرة البريدية',
    },

    // بشارة للميزات المُعلَنة التي لم تُطلق بعد.
    comingSoon: 'قريباً',

    // وصف زر الإغلاق لإمكانية الوصول.
    dismiss: 'إغلاق',
  },
};

export default promo;
